<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><a id="page_1">Murder at the Petroglyphs</a></h1><a id="page_1">
<p class="subtitle">A Harrie McKinsey Mystery</p>
<p class="author">Patricia Smith Wood</p>
<div class="image_container">
<p class="image"><img alt="images" src="images/logo.jpg"/></p>
</div>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Title.vue?5907ea13